import { render, staticRenderFns } from "./ActivityFormPanelReminder.vue?vue&type=template&id=5c074958&scoped=true&"
import script from "./ActivityFormPanelReminder.vue?vue&type=script&lang=js&"
export * from "./ActivityFormPanelReminder.vue?vue&type=script&lang=js&"
import style0 from "./ActivityFormPanelReminder.vue?vue&type=style&index=0&id=5c074958&prod&scoped=true&lang=scss&"
import style1 from "./ActivityFormPanelReminder.vue?vue&type=style&index=1&id=5c074958&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c074958",
  null
  
)

export default component.exports